import { render, staticRenderFns } from "./openPrice.vue?vue&type=template&id=57f8fc2a&"
import script from "./openPrice.vue?vue&type=script&lang=js&"
export * from "./openPrice.vue?vue&type=script&lang=js&"
import style0 from "./openPrice.vue?vue&type=style&index=0&lang=css&"
import style1 from "./openPrice.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports